import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Detail, Layout } from '../views/index';

function App() {
  const [mainRef, setMainRef] = useState(null);
  const [screenWidth, setScreenWidth] = useState(0);
  const [search] = useSearchParams();
  const readerId = search.get('coisar_reader');
  const comingFromOutside = !!search.get('coming_from_outside');

  // This has to be done with a resize event. A change in a ref doesn't trigger
  // a rerender so this will only have an effect when the app re-renders for
  // another reason and incidentally picks up the new width
  useEffect(() => {
    const handler = () => {
      const nextScreenWidth = mainRef ? mainRef.offsetWidth : 0;
      setScreenWidth(nextScreenWidth);
    };

    // We have to call the handler to trigger the initial value of
    // "screenWidth"
    handler();
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [mainRef]);

  return (
    <div
        // using a ref callback because we need to know when the ref has been
        // set.
        // See: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
      ref={(node) => setMainRef(node)}
      className="App"
    >
      {!readerId && <Layout screenWidth={screenWidth} />}
      {readerId && (
        <Detail
          readerId={readerId}
          comingFromOutside={comingFromOutside}
        />
      )}
    </div>
  );
}

export default App;
